<template>
  <div class="d-flex align-center" style="min-height: 40px">
    <v-chip
      v-for="word in keywords"
      :key="word"
      class="ma-2"
      close
      @click:close="onClickRemove(word)"
      color="gray"
      text-color="black"
      small
    >
      {{ word }}
    </v-chip>
  </div>
</template>

<script>
export default {
  model: {
    prop: "keywords",
    event: "change",
  },
  props: {
    keywords: {
      type: Array,
      required: true,
    },
  },
  methods: {
    onClickRemove(word) {
      this.$emit("clickRemove", word);
    },
  },
};
</script>

<style></style>
